import React, { createContext, useState } from "react";

export const FeatureFlagContext = createContext();

export const FeatureFlagProvider = (props) => {
   const defaultFlagSettings = {
      //alphabetize these
      //All the names of the feature Flags and their default setting true= on, false = off
      "Feature Flag Test Section": true,
      "info-panel": false,
      // histograms
      "mobile-view": false,
      "User Component (Old)": true,
      "User Profile (New)": false,
      "Widgets Page Example": false,
      "test-flag1": false,
      "test-flag2": true,
   };
   const flagDescription = {
      // This is where the description of each feature flag goes.
      // Make sure the order of each flag is in the same order as in defaultFlagSettings.
      "Feature Flag Test Section":
         "This is a test that turns on and off a section with a feature flag",
      "info-panel": "This is a test for the description of info-panel",
      // histograms
      "mobile-view": "This is a test for the description of mobile-view",
      "User Component (Old)":
         "This displays the Old User Component, without the option to click on a username.",
      "User Profile (New)":
         "This displays the New User Component. It has the option to click on a username and displays the user's profile.",
      "Widgets Page Example":
         "This is a test for the description of Widgets Page Example",
   };

   const [flagSettings, setFlagSettings] = useState({ ...defaultFlagSettings });

   return (
      <FeatureFlagContext.Provider
         value={{
            //alphabetize these
            defaultFlagSettings: defaultFlagSettings,
            flagSettings: flagSettings,
            flagDescription: flagDescription,
            setFlagSettings: setFlagSettings,
         }}
      >
         {props.children}
      </FeatureFlagContext.Provider>
   );
};
